import { Space } from 'STORE/Spaces/Space';

import { checkSearchString } from './checkSearchString';

export const checkSearchSpace = (space: Space, searchText: string): boolean => {
  return checkSearchString(space.name, searchText) && !space.isGuest;
};
